var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvdRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 12,
    fill: "#FBF0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0002 16.9387C36.2497 13.2276 40.6831 15.359 42.5413 19.013C43.5344 20.966 44.334 24.4305 43.8595 28.0457H37.1415L36.2644 26.2183C35.9015 25.355 34.687 25.2645 34.2143 26.0977L33.4986 27.3585L32.0325 21.5273C31.7968 20.3531 30.1169 20.2834 29.7999 21.4521L28.2298 27.2287L27.7098 25.3046C27.4786 24.4363 26.3585 24.1524 25.7483 24.8419L22.9055 28.0457H14.1405C13.666 24.4305 14.4656 20.966 15.4591 19.013C17.3169 15.359 21.7502 13.2276 29.0002 16.9387ZM43.3784 30.3411C41.8248 35.6419 33.8172 41.8287 29.0002 42.6819C24.1832 41.8283 16.1756 35.6423 14.622 30.3415H23.4159C23.7934 30.3415 24.1281 30.1589 24.3373 29.8781L26.0495 27.9486L27.1169 31.9193C27.4197 33.0518 29.0268 33.0403 29.3311 31.9232L30.865 26.2838L31.9717 30.6863C32.2309 31.724 33.6388 31.8604 34.1092 30.9209L35.1257 29.1293L35.3934 29.6867C35.5895 30.0969 35.9982 30.3365 36.4246 30.3369L43.3784 30.3411Z",
    fill: "#CA6B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvdRisk);
export default __webpack_public_path__ + "static/media/cvd_risk.cac2e8e7a8e881d21891f3cc301192f0.svg";
export { ForwardRef as ReactComponent };